import { type ComponentType, lazy, Suspense, useMemo } from "react";

import { MDXProvider } from "@mdx-js/react";

import { locales } from "../../docs.config.js";
import { useLocale } from "../lib/i18n.jsx";
import components from "../theme/MDXComponents.jsx";

// Texto editorial de uma tag da referência, escrito em MDX e servido junto com
// o spec, que é gerado. O spec vem do backend em runtime e não dá para editar
// daqui; este é o lugar de coisas como "as credenciais do sandbox são estas".
//
// Arquivo: content/<locale>/api/<tag-slug>.mdx. Sem arquivo, não renderiza nada.
// Sem tradução, cai no idioma de fallback, como as páginas de guia.
const loaders = import.meta.glob("/content/*/api/*.mdx") as Record<string, () => Promise<{ default: ComponentType }>>;

function pick(locale: string, tagId: string): (() => Promise<{ default: ComponentType }>) | null {
  return (
    loaders[`/content/${locale}/api/${tagId}.mdx`] ?? loaders[`/content/${locales.fallback}/api/${tagId}.mdx`] ?? null
  );
}

export default function TagIntro({ tagId }: { tagId: string }) {
  const { locale } = useLocale();
  const loader = pick(locale, tagId);
  const Body = useMemo(() => (loader ? lazy(loader) : null), [loader]);
  if (!Body) return null;
  return (
    <div className="ref-tag-intro">
      <MDXProvider components={components}>
        <Suspense fallback={null}>
          <Body />
        </Suspense>
      </MDXProvider>
    </div>
  );
}
